import { ICountryDetail } from "../types/types";

export const USER_TYPE = 0;

export const TIMEZONES = [
  { value: 0, label: "Choose One" },
  { value: 1, label: "Australian Eastern Standard Time" },
  { value: 2, label: "Australian Central Standard Time" },
  { value: 3, label: "Australian Western Standard Time" }
];

export const COUNTRY_LIST = [
  { code: "US", description: "United States" },
  { code: "CA", description: "Canada" }
];

export const COUNTRY_CODES = {
  US: ["US", "USA", "U.S", "U.S.A"],
  CA: ["CA", "CAN", "C.A", "C.A.N"]
};

export const countries: ICountryDetail[] = [
  { code: "", description: "Choose One", currency: "" },
  { code: "ALL", description: "All", currency: "" },
  { code: "US", description: "United States", currency: "USD" },
  { code: "CA", description: "Canada", currency: "CAD" }
];
